import { render, staticRenderFns } from "./FileTemplate.vue?vue&type=template&id=719d3b16"
import script from "./FileTemplate.vue?vue&type=script&lang=js"
export * from "./FileTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports